import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            <span className="purple">Hello</span>, I am Viraj Kulkarni<br/>
            MSc Business Analytics, BSc Computer Science
            <br />
            <br />
            My journey started with a Computer Science degree, where I built the 
            technical foundations of coding and problem-solving. But I soon discovered 
            that the real magic happens when numbers and logic meet business needs. 
            That led me into analytics—where I could combine both worlds.
            <br />
            <br />
            Since then, I’ve:
            <br />
            <br />
            <span className="purple">At TCS</span> – worked as a Business Analyst, gathering requirements, 
            mapping processes, and helping stakeholders translate challenges into solutions.
            <br />
            <br />
            <span className="purple">At Redeployable</span> – turned unstructured data into a working AI model 
            for skill-mapping, while designing dashboards that executives could actually use.
            <br />
            <br />
            <span className="purple">At We’ve Got The Key (WGTK)</span> – taken ownership of the data function, 
            building SQL pipelines, automating reporting flows, and delivering dashboards 
            that track performance across operations and finance.
            <br />
            <br />
            What ties it all together is a single approach: I don’t just analyse data— 
            I ask <span className="purple">“what does this mean for the business?”</span>. Whether I’m gathering 
            requirements in a workshop, writing SQL to uncover patterns, or presenting KPIs 
            to leadership, I make sure the numbers translate into decisions and action.
            <br />
            <br />
            Outside work, you’ll usually find me:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Swimming to clear my mind
            </li>
            <li className="about-activity">
              <ImPointRight /> Trekking and exploring new places
            </li>
            <li className="about-activity">
              <ImPointRight /> Keeping up with the latest AI trends (because curiosity never stops)
            </li>
          </ul>

          <p style={{ color: "#FFD700" }}>
            "Decoding Data, Driving Growth – Insightful Analysis for Impactful Decisions"{" "}
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
